import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import axios from "axios";

Vue.use(VueRouter);

// Layout
import UnAuthLayout from "../views/layouts/unauth-layout.vue";
import AuthLayout from "../views/layouts/auth-layout.vue";

// Static
import HomePage from "../views/home";

// Auth
import LoginPage from "../views/auth/login.vue";
import ForgotPasswordPage from "../views/auth/forgot-password.vue";

// Companies
import CompaniesPage from "../views/companies/index.vue";
import CompanyCreatePage from "../views/companies/create.vue";
import CompanyIdPage from "../views/companies/id.vue";

// Users
import UsersPage from "../views/users/index.vue";
import ReferralUsersPage from "../views/users/referral-users.vue";
import WithdrawalStatusPage from "../views/users/withdrawal-status.vue";
import DepositStatusPage from "../views/users/deposit-status.vue";
import TransactionsPage from "../views/users/transactions.vue";
import UserCreatePage from "../views/users/create.vue";
import UserIdPage from "../views/users/id.vue";
import ProfilePage from "../views/users/id.vue";
import UserInvestmentsPage from "../views/users/investments.vue";
import UserKycDocumentsPage from "../views/users/kyc-documents.vue";
import UsersUploadPage from "../views/users/upload.vue";

// Positions
import PositionsPage from "../views/positions/index.vue";
import PositionCreatePage from "../views/positions/create.vue";
import PositionIdPage from "../views/positions/id.vue";

// Roles
import RolesPage from "../views/roles/index.vue";
import RoleIdPage from "../views/roles/id.vue";

// Modules
import ModulesPage from "../views/modules/index.vue";
import ModuleCreatePage from "../views/modules/create.vue";
import ModuleIdPage from "../views/modules/id.vue";

// Outlets
import OutletsPage from "../views/outlets/index.vue";
import OutletCreatePage from "../views/outlets/create.vue";
import OutletIdPage from "../views/outlets/id.vue";
import OutletsUploadPage from "../views/outlets/upload.vue";

// Outlet Users
import OutletUsersPage from "../views/outlets/outlet-users/index.vue";
import OutletUserCreatePage from "../views/outlets/outlet-users/create.vue";
import OutletUserIdPage from "../views/outlets/outlet-users/id.vue";

// Pjps
import PjpsPage from "../views/pjps/index.vue";
import PjpCreatePage from "../views/pjps/create.vue";
import PjpIdPage from "../views/pjps/id.vue";
import PjpsUploadPage from "../views/pjps/upload.vue";
import PjpCopyReferencesPage from "../views/pjps/copy-pjp-references.vue";
import PjpCopyPreviousMonth from "../views/pjps/copy-pjp-prev-month.vue";

// PjpReferences
import PjpReferencesPage from "../views/pjp-references/index.vue";
import PjpReferenceCreatePage from "../views/pjp-references/create.vue";
import PjpReferenceIdPage from "../views/pjp-references/id.vue";

// Permissions
import PermissionsPage from "../views/permissions/index.vue";
import PermissionCreatePage from "../views/permissions/create.vue";
import PermissionIdPage from "../views/permissions/id.vue";

// Values
import Values from "@/views/values/index.vue";
import ValueCreate from "@/views/values/create.vue";
import ValueId from "@/views/values/id.vue";

// ValueLists
import ValueLists from "@/views/value-lists/index.vue";
import ValueListUpload from "@/views/value-lists/upload.vue";
import ValueListCreate from "@/views/value-lists/create.vue";
import ValueListId from "@/views/value-lists/id.vue";

// User Timestamps
import UserTimestamps from "@/views/user-timestamps/index.vue";

//producttype
import ProductTypesPage from "../views/product-types/index.vue";
import ProductTypeCreatePage from "../views/product-types/create.vue";
import ProductTypeIdPage from "../views/product-types/id.vue";
//products
import ProductsPage from "../views/products/index.vue";
import ProductCreatePage from "../views/products/create.vue";
import ProductIdPage from "../views/products/id.vue";
import ProductInvestmentsPage from "../views/products/investments.vue";
import ProductTransactionsPage from "../views/products/transactions.vue";
//productagreements
import ProductsAgreementPage from "../views/product-agreements/index.vue";
import ProductAgreementCreatePage from "../views/product-agreements/create.vue";
import ProductAgreementIdPage from "../views/product-agreements/id.vue";
//categpries
import CategoriesPage from "../views/categories/index.vue";
import CategoryCreatePage from "../views/categories/create.vue";
import CategoryIdPage from "../views/categories/id.vue";
//subcategory
import SubcategoryPage from "../views/sub-categories/index.vue";
import SubcategoryCreatePage from "../views/sub-categories/create.vue";
import SubcategoryIdPage from "../views/sub-categories/id.vue";

// Investments
import InvestmentsPage from "../views/investments/index.vue";
import InvestmentCreatePage from "../views/investments/create.vue";
import InvestmentIdPage from "../views/investments/id.vue";

// Company Details
import AboutUsPage from "../views/company-details/about-us.vue";
import ContactUsPage from "../views/company-details/contact-us.vue";
import PrivacyPolicyPage from "../views/company-details/privacy-policies.vue";
import TermsConditionPage from "../views/company-details/terms-conditions.vue";
import CompanyBankDetailPage from "../views/company-details/bank-detail.vue";

// Company Details
import TicketsPage from "../views/tickets/index.vue";

// RMC Management
import RmcPlantsPage from "../views/rmc-plants/index.vue";
import RmcBookingsPage from "../views/rmc-bookings/index.vue";
import RmcOrdersPage from "../views/rmc-orders/index.vue";
import RmcMarketplacePage from "../views/rmc-marketplace/index.vue";
import RmcDeliveriesPage from "../views/rmc-deliveries/index.vue";
import RmcMembershipPlansPage from "../views/rmc-plans/index.vue";
import RmcSubscriptionsPage from "../views/rmc-subscriptions/index.vue";

// Cancellations Logs
import DeleteAccountRequestPage from "../views/delete-requests/create.vue";
import DeleteAccountRequestIndexPage from "../views/delete-requests/index.vue";

const routes = [
  // AuthLayout
  {
    path: "/auth",
    name: "AuthLayout",
    component: AuthLayout,
    children: [
      {
        path: "/home",
        name: "HomePage",
        component: HomePage,
      },
      // Comapnies
      {
        path: "/companies",
        name: "CompaniesPage",
        component: CompaniesPage,
      },
      {
        path: "/companies/create",
        name: "CompanyCreatePage",
        component: CompanyCreatePage,
      },
      {
        path: "/companies/:companyId",
        name: "CompanyIdPage",
        component: CompanyIdPage,
      },
      // Users
      {
        path: "/users",
        name: "UsersPage",
        component: UsersPage,
      },
      {
        path: "/users/withdrawal-status",
        name: "WithdrawalStatusPage",
        component: WithdrawalStatusPage,
      },
      {
        path: "/users/deposit-status",
        name: "DepositStatusPage",
        component: DepositStatusPage,
      },
      {
        path: "/referral-users",
        name: "ReferralUsersPage",
        component: ReferralUsersPage,
      },
      {
        path: "/users/transactions/:userId",
        name: "TransactionsPage",
        component: TransactionsPage,
      },
      {
        path: "/users/create",
        name: "UserCreatePage",
        component: UserCreatePage,
      },
      {
        path: "/users/upload",
        name: "UsersUploadPage",
        component: UsersUploadPage,
      },
      {
        path: "/profile/:userId",
        name: "ProfilePage",
        component: ProfilePage,
      },
      {
        path: "/users/:userId",
        name: "UserIdPage",
        component: UserIdPage,
      },
      {
        path: "/users/investments/:userId",
        name: "UserInvestmentsPage",
        component: UserInvestmentsPage,
      },
      {
        path: "/users/kyc-documents/:userId",
        name: "UserKycDocumentsPage",
        component: UserKycDocumentsPage,
      },
      {
        path: "/users/:userId/bankdetails",
        name: "UserBankDetailsPage",
        component: () => import("@/views/users/bank-details.vue"),
      },
      // Positions
      {
        path: "/positions",
        name: "PositionsPage",
        component: PositionsPage,
      },
      {
        path: "/positions/create",
        name: "PositionCreatePage",
        component: PositionCreatePage,
      },
      {
        path: "/positions/:positionId",
        name: "PositionIdPage",
        component: PositionIdPage,
      },
      // Roles
      {
        path: "/roles",
        name: "RolesPage",
        component: RolesPage,
      },
      {
        path: "/roles/:roleId",
        name: "RoleIdPage",
        component: RoleIdPage,
      },
      // Modules
      {
        path: "/modules",
        name: "ModulesPage",
        component: ModulesPage,
      },
      {
        path: "/modules/create",
        name: "ModuleCreatePage",
        component: ModuleCreatePage,
      },
      {
        path: "/modules/:moduleId",
        name: "ModuleIdPage",
        component: ModuleIdPage,
      },
      // Permissions
      {
        path: "/permissions",
        name: "PermissionsPage",
        component: PermissionsPage,
      },
      {
        path: "/permissions/create",
        name: "PermissionCreatePage",
        component: PermissionCreatePage,
      },
      {
        path: "/permissions/:permissionId",
        name: "PermissionIdPage",
        component: PermissionIdPage,
      },
      // Values
      {
        path: "/values",
        name: "Values",
        component: Values,
      },
      {
        path: "/values/create",
        name: "ValueCreate",
        component: ValueCreate,
      },
      {
        path: "/values/:valueId",
        name: "ValueId",
        component: ValueId,
      },
      // ValueLists
      {
        path: "/value-lists",
        name: "ValueLists",
        component: ValueLists,
      },
      {
        path: "/value-lists/upload",
        name: "ValueListUpload",
        component: ValueListUpload,
      },
      {
        path: "/value-lists/create",
        name: "ValueListCreate",
        component: ValueListCreate,
      },
      {
        path: "/value-lists/:valueListId",
        name: "ValueListId",
        component: ValueListId,
      },
      // Outlets
      {
        path: "/outlets",
        name: "OutletsPage",
        component: OutletsPage,
      },
      {
        path: "/outlets/upload",
        name: "OutletsUploadPage",
        component: OutletsUploadPage,
      },
      {
        path: "/outlets/create",
        name: "OutletCreatePage",
        component: OutletCreatePage,
      },
      {
        path: "/outlets/:outletId",
        name: "OutletIdPage",
        component: OutletIdPage,
      },
      // OutletUsers
      {
        path: "/outlets/:outletId/outlet-users",
        name: "OutletUsersPage",
        component: OutletUsersPage,
      },
      {
        path: "/outlets/:outletId/outlet-users/create",
        name: "OutletUserCreatePage",
        component: OutletUserCreatePage,
      },
      {
        path: "/outlet-users/:outletUserId",
        name: "OutletUserIdPage",
        component: OutletUserIdPage,
      },
      // Pjps
      {
        path: "/pjps",
        name: "PjpsPage",
        component: PjpsPage,
      },
      {
        path: "/pjps/upload",
        name: "PjpsUploadPage",
        component: PjpsUploadPage,
      },
      {
        path: "/pjps/copy-pjp-references",
        name: "PjpCopyReferencesPage",
        component: PjpCopyReferencesPage,
      },
      {
        path: "/pjps/copy-pjp-prev-month",
        name: "PjpCopyPreviousMonth",
        component: PjpCopyPreviousMonth,
      },
      {
        path: "/pjps/create",
        name: "PjpCreatePage",
        component: PjpCreatePage,
      },
      {
        path: "/pjps/:pjpId",
        name: "PjpIdPage",
        component: PjpIdPage,
      },
      // PjpReferences
      {
        path: "/pjp-references",
        name: "PjpReferencesPage",
        component: PjpReferencesPage,
      },
      {
        path: "/pjp-references/create",
        name: "PjpReferenceCreatePage",
        component: PjpReferenceCreatePage,
      },
      {
        path: "/pjp-references/:pjpReferenceId",
        name: "PjpReferenceIdPage",
        component: PjpReferenceIdPage,
      },
      // UserTimestamps
      {
        path: "/user-timestamps",
        name: "UserTimestamps",
        component: UserTimestamps,
      },
      // Product Types
      {
        path: "/product-types",
        name: "ProductTypesPage",
        component: ProductTypesPage,
      },
      {
        path: "/product-types/create",
        name: "ProductTypeCreatePage",
        component: ProductTypeCreatePage,
      },
      {
        path: "/product-types/:productTypeId",
        name: "ProductTypeIdPage",
        component: ProductTypeIdPage,
      },

      // Product Agreements
      {
        path: "/product-agreements",
        name: "ProductsAgreementPage",
        component: ProductsAgreementPage,
      },
      {
        path: "/product-agreements/create",
        name: "ProductAgreementCreatePage",
        component: ProductAgreementCreatePage,
      },
      {
        path: "/product-agreements/:productAgreementId",
        name: "ProductAgreementIdPage",
        component: ProductAgreementIdPage,
      },

      // Products
      {
        path: "/products",
        name: "ProductsPage",
        component: ProductsPage,
      },
      {
        path: "/products/create",
        name: "ProductCreatePage",
        component: ProductCreatePage,
      },
      {
        path: "/products/:productsId",
        name: "ProductIdPage",
        component: ProductIdPage,
      },
      {
        path: "/products/investments/:productId",
        name: "ProductInvestmentsPage",
        component: ProductInvestmentsPage,
      },
      {
        path: "/products/transactions/:productId",
        name: "ProductTransactionsPage",
        component: ProductTransactionsPage,
      },
      // Categories
      {
        path: "/categories",
        name: "CategoriesPage",
        component: CategoriesPage,
      },
      {
        path: "/categories/create",
        name: "CategoryCreatePage",
        component: CategoryCreatePage,
      },
      {
        path: "/categories/:categoryId",
        name: "CategoryIdPage",
        component: CategoryIdPage,
      },
      {
        path: "/categories/:categoryId/sub-categories",
        name: "SubcategoryPage",
        component: SubcategoryPage,
      },
      {
        path: "/categories/:categoryId/sub-categories/create",
        name: "SubCategoryCreatePage",
        component: SubcategoryCreatePage,
      },
      {
        // path: "categories/:categoryId/sub-categories/:sub_categoryId",
        path: "/categories/:categoryId/sub-categories/:subcategoryId",
        name: "SubcategoryIdPage",
        component: SubcategoryIdPage,
      },
      // Investments
      {
        path: "/investments",
        name: "InvestmentsPage",
        component: InvestmentsPage,
      },
      {
        path: "/investments/create",
        name: "InvestmentCreatePage",
        component: InvestmentCreatePage,
      },
      {
        path: "/investments/:investmentId",
        name: "InvestmentIdPage",
        component: InvestmentIdPage,
      },
      // Company Details
      {
        path: "/about-us",
        name: "AboutUsPage",
        component: AboutUsPage,
      },
      {
        path: "/contact-us",
        name: "ContactUsPage",
        component: ContactUsPage,
      },
      {
        path: "/privacy-policies",
        name: "PrivacyPolicyPage",
        component: PrivacyPolicyPage,
      },
      {
        path: "/terms-conditions",
        name: "TermsConditionPage",
        component: TermsConditionPage,
      },
      {
        path: "/company-bank-detail",
        name: "CompanyBankDetailPage",
        component: CompanyBankDetailPage,
      },
      // Tickets
      {
        path: "/tickets",
        name: "TicketsPage",
        component: TicketsPage,
      },
      //DeletedAccountRequest Logs,
      {
        path: "/account-delete-request",
        name: "DeleteAccountRequestIndexPage",
        component: DeleteAccountRequestIndexPage,
      },

      // RMC Management
      {
        path: "/rmc-plants",
        name: "RmcPlantsPage",
        component: RmcPlantsPage,
      },
      {
        path: "/rmc-bookings",
        name: "RmcBookingsPage",
        component: RmcBookingsPage,
      },
      {
        path: "/rmc-orders",
        name: "RmcOrdersPage",
        component: RmcOrdersPage,
      },
      {
        path: "/rmc-marketplace",
        name: "RmcMarketplacePage",
        component: RmcMarketplacePage,
      },
      {
        path: "/rmc-deliveries",
        name: "RmcDeliveriesPage",
        component: RmcDeliveriesPage,
      },
      {
        path: "/rmc-plans",
        name: "RmcMembershipPlansPage",
        component: RmcMembershipPlansPage,
      },
      {
        path: "/rmc-subscriptions",
        name: "RmcSubscriptionsPage",
        component: RmcSubscriptionsPage,
      },

      // Bank Details
      {
        path: "/bank_details",
        name: "BankDetailsPage",
        component: () => import("@/views/bank_details/index.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/bank_details/create",
        name: "BankDetailCreatePage",
        component: () => import("@/views/bank_details/create.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/bank_details/:id",
        name: "BankDetailIdPage",
        component: () => import("@/views/bank_details/id.vue"),
        meta: { requiresAuth: true },
      },
      // Product Enquiries
      {
        path: "/product_enquiries",
        name: "ProductEnquiriesPage",
        component: () => import("@/views/product_enquiries/index.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/product_enquiries/create",
        name: "ProductEnquiryCreatePage",
        component: () => import("@/views/product_enquiries/create.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/product_enquiries/:id",
        name: "ProductEnquiryIdPage",
        component: () => import("@/views/product_enquiries/id.vue"),
        meta: { requiresAuth: true },
      },
    ],
  },
  // End AuthLayout

  // UnAuthLayout
  {
    path: "/unauth",
    name: "UnAuthLayout",
    component: UnAuthLayout,
    children: [
      {
        path: "/login",
        name: "LoginPage",
        component: LoginPage,
      },
      {
        path: "/forgot-password",
        name: "ForgotPasswordPage",
        component: ForgotPasswordPage,
      },
      {
        path: "/account-delete-request/create",
        name: "DeleteAccountRequestPage",
        component: DeleteAccountRequestPage,
      },
      {
        path: "/privacy-policies",
        name: "PublicPrivacyPolicyPage",
        component: PrivacyPolicyPage,
      },
      {
        path: "/terms-conditions",
        name: "PublicTermsConditionPage",
        component: TermsConditionPage,
      },
    ],
  },
  //End UnAuthLayout
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (store.getters["auth/authenticated"] && from.name) {
    to.params.startTime = new Date();
  }
  // Pages accessible for both auth and unauth users
  // For unauthenticated users, redirect to public versions (no navbar/sidebar)
  if (!store.getters["auth/authenticated"]) {
    if (to.name === "PrivacyPolicyPage") {
      return next({ name: "PublicPrivacyPolicyPage" });
    }
    if (to.name === "TermsConditionPage") {
      return next({ name: "PublicTermsConditionPage" });
    }
  }
  if (
    to.name === "DeleteAccountRequestPage" ||
    to.name === "PublicPrivacyPolicyPage" ||
    to.name === "PublicTermsConditionPage" ||
    to.name === "PrivacyPolicyPage" ||
    to.name === "TermsConditionPage"
  ) {
    return next();
  }
  // Auth-only pages (redirect to home if already logged in)
  if (
    to.name === "LoginPage" ||
    to.name === "RegisterPage" ||
    to.name === "ForgotPasswordPage"
  ) {
    console.log("1");
    if (store.getters["auth/authenticated"]) {
      console.log("2");
      let company_id = store.getters["auth/company"].id;
      if (company_id) {
        console.log("3");
        console.log(company_id);
      }
      return next({
        name: "HomePage",
      });
    }
    next();
  } else if (!store.getters["auth/authenticated"]) {
    console.log("4");
    return next({
      name: "LoginPage",
    });
  } else if (to.name === null) {
    console.log("5");
    return next({
      name: "HomePage",
    });
  }
  next();
});

router.afterEach(async (to, from) => {
  if (
    store.getters["auth/authenticated"] &&
    from.name &&
    !to.name.includes("Create") &&
    !to.name.includes("Edit")
  ) {
    let endTime = new Date();
    let startTime = from.params.startTime;
    let timeSpentInSeconds = "0";
    if (startTime) {
      timeSpentInSeconds = (endTime - startTime) / 1000;
    }
    if (timeSpentInSeconds > 1200) {
      timeSpentInSeconds = 1200;
    }
    console.log(
      `Time spent on "${to.name}" route: ${timeSpentInSeconds} seconds`
    );
    let form = {
      from_path: from.path,
      from_name: from.name,
      user_id: store.getters["auth/user"].id,
      timespent: timeSpentInSeconds,
    };
    await axios.post(`/user_timestamps`, form);
  }
});

export default router;
